import axios from 'axios'
import {ObservationModel, ResponseCRUD, ResponseObject, ResponseObjectPaginated} from '../model'
const BASEURL = process.env.REACT_APP_DEV_API_LAVANDERIA_URL
export function getObservation(dto: ObservationModel, pageNumber: number) {
  return axios.post<ResponseObjectPaginated<ObservationModel[]>>(
    `${BASEURL}/maintenanceinspection/getAllObservationInspection/${pageNumber}?size=10`,
    dto,
  )
}
export function getObservationById(dto: string | undefined) {
  return axios.get<ResponseObject<ObservationModel>>(
    `${BASEURL}/maintenanceinspection/getInformationById?id=${dto}`,
  )
}

export function createObservation(dto: ObservationModel) {
  return axios.post<ResponseCRUD>(
    `${BASEURL}/maintenanceinspection/createObservationMaintenanceInspection`,
    dto,
  )
}

export function deleteObservation(dto: any) {
  return axios.delete<ResponseCRUD>(
    `${BASEURL}/maintenanceinspection/deleteObservationMaintenanceInspection?ObservacionMantenimientoInspeccionId=${dto}`,
  )
}

export function updateObservation(dto: ObservationModel) {
  return axios.post<ResponseCRUD>(
    `${BASEURL}/maintenanceinspection/updateObservationMaintenanceInspection`,
    dto,
  )
}
